<template>
  <div class="footer-area text-center mt-25 bg-white border-top-radius">
    <p>
      ©
      <span>MahAi.</span>
      Tüm hakları saklıdır. MahAi hata yapabilir. Lütfen cevapların doğruluğunu teyid ediniz.
      <a href="#" @click.prevent="principlesVisible = true">Yapay Zeka Kullanım İlkeleri için tıklayınız.</a>
    </p>

    <!-- AI PRINCIPLES MODAL -->
    <teleport to="body">
      <div v-if="principlesVisible" class="fp-modal-backdrop" @click.self="principlesVisible = false">
        <div class="fp-modal">
          <div class="fp-modal-header">
            <span class="material-symbols-outlined" style="color:#1a5f4a;font-size:22px;">gavel</span>
            <h3>Yapay Zeka Kullanım İlkeleri Kılavuzu</h3>
            <button class="fp-modal-close" @click="principlesVisible = false">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>
          <div class="fp-modal-body">
            <p class="fp-intro">
              Bu kılavuz yargıçların görevleri icabı veya yargısal herhangi bir işlemde yapay zeka araçlarının
              kullanımı konusunda uyması gereken ilkeleri düzenlemektedir.
            </p>
            <ol class="fp-list">
              <li>Mahkemeler tarafından kullanıma sunulsun veya sunulmasın, herhangi bir yapay zeka aracı kullanılmadan önce, kullanılacak yapay zeka aracının yetenekler ve potansiyel sınırlamaları hakkında temel bilgiye sahip olunduğundan emin olunmalıdır.</li>
              <li>Yapay zeka araçları sorduğunuz her soruyu, girdiğiniz her türlü bilgiyi hatırlamaktadır. Bunlar daha sonra başka kullanıcıların sorularına yanıt vermek için kullanılabilmektedir.</li>
              <li>Yapay zeka araçlarının yargısal işlemler ile alakalı kullanılacağı durumlarda, siber güvenliğin sağlandığından emin olunmalıdır. Bu maksatla yapay zekanın yargısal işlemler ile ilgili olarak kullanılacağı durumlarda yapay zeka araçlarına Mahkeme ortamında sağlanan ağ hizmetlerinden erişilmesi en doğru yaklaşım olacaktır.</li>
              <li>Bir yapay zeka aracı tarafından size sağlanan herhangi bir bilginin doğruluğu, bu bilgi kullanılmadan veya bu bilgiye güvenilmeden önce kontrol edilmelidir.</li>
              <li>Yapay zeka araçları tarafından sağlanan bilgiler, yanlış, eksik, yanıltıcı olabilir veya güncel olmayabilir. Yapay zeka tarafından üretilen cevap veya materyal Kuzey Kıbrıs Türk Cumhuriyeti'nde yürürlükte olan mevzuatı kapsadığını belirtse bile, bu doğru olmayabilir. Buna yapay zeka aracının halüsinasyon görmesi sonucu ortaya çıkmış olabilecek kaynak ve alıntılar da dahildir.</li>
              <li>Yapay zeka araçları tarafından üretilen tüm içerikler bağımsız kaynaklardan doğrulanmadan kullanılmamalıdır.</li>
              <li>
                Yapay zeka araçları halüsinasyon görebilirler. Yapay zeka araçlarının halüsinasyon görmesi aşağıdaki formlarda olabilir;
                <ul>
                  <li>hayali davalar, alıntılar veya sözler uydurmak ya da var olmayan mevzuat, makaleler veya hukuki metinlere atıfta bulunmak,</li>
                  <li>yasa veya yasanın nasıl uygulanabileceği konusunda yanlış ya da yanıltıcı bilgiler vermek, ve</li>
                  <li>gerçeğe aykırı olgusal hatalar yapmak.</li>
                </ul>
              </li>
              <li>Yargıçlar her zaman huzurlarındaki yargısal işlem ile ilgili layiha, doküman veya sair yargısal işlem ile ilgili belgeyi okuyup değerlendirmelidirler. Yapay zeka araçları yardımcı olabilir, ancak şahadetin ve olgusal değerlendirmede doğrudan ilgilenmenin yerini almazlar.</li>
              <li>Yapay zeka araçlarının avukatlar veya avukat tarafından temsil edilmeyen kişiler tarafından da kullanılabileceği unutulmamalıdır. Yapay zeka tarafından materyallerde insan gözünün göremeyeceği ancak bilgisayar sistemleri tarafından algılanabilen gizli komut ya da saklı materyallerin yerleştirilmesi ile oluşan "beyaz metin" olarak adlandırılan sahte içeriklerin de bulunabileceğinden ötürü yargısal işlemler sırasında Mahkemenin dikkatine getirilen metin ve/veya dokümanların doğruluğu teyit edilmelidir.</li>
            </ol>
            <div class="fp-signature">
              <span class="material-symbols-outlined">account_balance</span>
              <span>YÜKSEK MAHKEME</span>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      principlesVisible: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer-area {
  padding: 18.5px 30px;

  span {
    color: #ad63f6;
  }
  a {
    color: var(--primaryColor);
    cursor: pointer;
  }
}

@media only screen and (max-width: 991px) {
  .footer-area {
    p {
      padding: 10px 10px;
    }
  }
}
</style>

<style>
.fp-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(28, 37, 32, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.fp-modal {
  width: min(680px, 94vw);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  background: #f8f9f5;
  border-radius: 12px;
  border: 1px solid #d4d9ce;
  border-left: 4px solid #1a5f4a;
  box-shadow: 0 20px 50px rgba(90, 98, 112, 0.15);
  overflow: hidden;
}

.fp-modal-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 22px;
  border-bottom: 1px solid #d4d9ce;
  background: #f0f2ec;
  flex-shrink: 0;
}

.fp-modal-header h3 {
  flex: 1;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a5f4a;
  font-family: 'Georgia', 'Times New Roman', serif;
}

.fp-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7a72;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  transition: background 0.15s;
}

.fp-modal-close:hover {
  background: #d4d9ce;
}

.fp-modal-body {
  overflow-y: auto;
  padding: 22px 24px 28px;
}

.fp-intro {
  font-size: 14px;
  line-height: 1.75;
  color: #4a5568;
  margin: 0 0 20px 0;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #d4d9ce;
  border-left: 4px solid #1a5f4a;
  border-radius: 0 8px 8px 0;
}

.fp-list {
  margin: 0 0 24px 0;
  padding: 0;
  list-style: none;
  counter-reset: fp-counter;
}

.fp-list > li {
  counter-increment: fp-counter;
  position: relative;
  padding: 14px 16px 14px 54px;
  margin-bottom: 8px;
  background: #fff;
  border: 1px solid #d4d9ce;
  border-radius: 10px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #4a5568;
  text-align: left;
}

.fp-list > li::before {
  content: counter(fp-counter);
  position: absolute;
  left: 14px;
  top: 14px;
  width: 26px;
  height: 26px;
  background: #1a5f4a;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
}

.fp-list > li > ul {
  margin: 10px 0 0 0;
  padding-left: 18px;
}

.fp-list > li > ul > li {
  font-size: 13px;
  line-height: 1.65;
  color: #6b7a72;
  margin-bottom: 4px;
  list-style: disc;
}

.fp-signature {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 0 0;
  border-top: 2px solid #d4d9ce;
  color: #1a5f4a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
}
</style>
